import momentJalaali from "moment-jalali";
import DatePicker from "react-datepicker2";
import { faBalanceScale } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { getAccountBalanceReport } from "../store/api/DocumentsAPI";
import BihamtaTable from "../../Components/BihamtaTable";
import { FileExcel, Printer, Search } from "react-bootstrap-icons";
import { exportToExcel } from "../../store/api/CommonFunctions";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const AccountBalanceReport = () => {
    const history = useHistory();
    const toDate = useRef(null);
    const [pending, setPending] = useState(false);
    const [debtList, setDebtList] = useState(null);
    const [creditList, setCreditList] = useState(null);
    function search() {
        const pToDate = document.getElementsByName("toDate")[0].value;
        if(pToDate === "")
        {
            toDate.current = null;
        }
        const onGet = (res) => {
            if (res.Data) {
                setDebtList({ Data: res.Data.filter(a => Number(a.RemainedDebit) !== 0) });
                setCreditList({ Data: res.Data.filter(a => Number(a.RemainedCredit) !== 0) });
            }
            else if (res === "PENDING") {
                setDebtList("PENDING");
                setCreditList("PENDING");
            }
        }
        getAccountBalanceReport(toDate.current, onGet);
    }
    function toExcel() {
        const url = "api/DocumentsAPI/GetAccountBalanceReport";
        const searchArgs = { toDate: toDate.current };
        setPending(true);
        exportToExcel("AccountBalanceReport", searchArgs, url, "get", debtCols, () => setPending(false));
    }
    function printReport(e) {
        const searchArgs = { toDate: toDate.current };
        history.push({
            pathname: `/PrintViewer/AccountBalanceReport/${e.ctrlKey}`,
            state: {
                dataUrl: `api/DocumentsAPI/GetAccountBalanceReport?toDate=${toDate.current}`,
                method: "get",
                fetchBody: JSON.stringify(searchArgs)
            }
        });
    }
    const debtCols = [
        { colTitle: "کد", colName: "AccountCode", justInMobile: true },
        { colTitle: "عنوان حساب", colName: "AccountName", justInMobile: true },
        { colTitle: "مبلغ", colName: "RemainedDebit", justInMobile: true, colType: "currency", showNegative: true, styleCondition: () => { return { direction: "ltr" } } },
        { colTitle: "", colName: "RemainedCredit", styleCondition: () => { return {display:"none" } }, headerStyle:{display:"none"}}
    ]
    const creditCols = [
        { colTitle: "کد", colName: "AccountCode", justInMobile: true },
        { colTitle: "عنوان حساب", colName: "AccountName", justInMobile: true },
        { colTitle: "مبلغ", colName: "RemainedCredit", justInMobile: true, colType: "currency", showNegative: true, styleCondition: () => { return { direction: "ltr" } } }
    ]
    useEffect(() => {
        document.body.classList = "notMain";
        search();
    }, [])
    return (
        <div className="container-fluid mt-2">
            <br />
            <Card>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faBalanceScale} size="lg" />
                    &nbsp;
                    ترازنامه
                </Card.Header>
                <Card.Body className="bodyStyle" style={{ textAlign: "right" }}>
                    <Row>
                        <Col md={2} className="form-group">
                            <label>ترازنامه تا تاریخ: </label>
                            <DatePicker className="form-control" name="toDate" isGregorian={false} timePicker={false}
                                onChange={value => toDate.current = value.local("en").format("YYYY-MM-DD")} />
                            <Button className="btn-input-tiny" onClick={search} style={{ top: 27 }}><Search size={23} /></Button>
                        </Col>
                    </Row>
                    <Row className="mb-1">
                        <Col md={6}>
                            <BihamtaTable columns={debtCols} dataList={debtList} />
                            <Form.Control readOnly value={debtList?.Data?.map(d=>d.RemainedDebit).reduce((a,b)=>a+b,0)?.toLocaleString("en")??0} style={{color:"red"}}/>
                        </Col>
                        <Col md={6}>
                            <BihamtaTable columns={creditCols} dataList={creditList} />
                            <Form.Control readOnly value={creditList?.Data?.map(d=>d.RemainedCredit).reduce((a,b)=>a+b,0)?.toLocaleString("en")??0} style={{color:"green"}}/>
                        </Col>
                    </Row>
                    <Button className="group-Btn-large" onClick={printReport} variant="secondary"><Printer size={17}/>&nbsp; چاپ گزارش</Button>
                    <Button className="group-Btn-large" onClick={toExcel} disabled={pending}><FileExcel size={17}/>&nbsp; ارسال به اکسل</Button>
                </Card.Body>
            </Card>
        </div>
    )

}
export default AccountBalanceReport;